"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var GoogleDrive = /** @class */ (function () {
    function GoogleDrive(config) {
        this.providerDisplay = 'Google Drive';
        this.providerName = 'googleDrive';
        this.providerUrl = 'http://drive.google.com/';
        this.providerIcon = 'https://ssl.gstatic.com/docs/documents/images/kix-favicon7.ico';
        this.type = 'rich';
        this.regex = /docs\.google\.com\/(?:document|spreadsheets)\/d.*\/([a-zA-Z0-9-_]+)\//;
        this.gApiLoaded = false;
        this.config = __assign({}, config);
    }
    GoogleDrive.prototype.loadExternal = function () {
        var _this = this;
        if (!this.config.apiKey)
            return;
        // Stop loading when Google Api is already loaded
        if (window.gApiLoaded)
            return;
        if (!document.getElementById('google-api')) {
            // Add script if not added already
            var script = document.createElement('script');
            script.id = 'google-api';
            script.src = 'https://apis.google.com/js/api.js';
            script.onload = function () {
                gapi.load('client', function () { return __awaiter(_this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        window.gApiLoaded = true;
                        return [2 /*return*/];
                    });
                }); });
            };
            document.body.appendChild(script);
        }
    };
    Object.defineProperty(GoogleDrive.prototype, "externalLoaded", {
        get: function () {
            var start_time = Date.now();
            return new Promise(function (resolve, reject) {
                var checkgApiLoaded = function () {
                    var googleApiLoaded = window.gApiLoaded;
                    if (googleApiLoaded) {
                        // Google Api is loaded so we can continue
                        resolve(googleApiLoaded);
                    }
                    else if (Date.now() > start_time + 10000) {
                        // Timeout after 10 seconds
                        reject(new Error('Could not load Google Drive embed'));
                    }
                    else {
                        // Google Api is not yet loaded, try again in a second
                        setTimeout(checkgApiLoaded, 1000);
                    }
                };
                checkgApiLoaded();
            });
        },
        enumerable: true,
        configurable: true
    });
    GoogleDrive.prototype.getApiData = function (url) {
        return __awaiter(this, void 0, void 0, function () {
            var urlMatch, documentId, request, e_1, _a, name, mimeType;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.config.apiKey)
                            return [2 /*return*/];
                        this.loadExternal();
                        // Wait until external scripts are loaded
                        return [4 /*yield*/, this.externalLoaded];
                    case 1:
                        // Wait until external scripts are loaded
                        _b.sent();
                        urlMatch = url.match(this.regex);
                        if (!urlMatch)
                            return [2 /*return*/];
                        documentId = urlMatch[1];
                        _b.label = 2;
                    case 2:
                        _b.trys.push([2, 5, , 6]);
                        return [4 /*yield*/, gapi.client.init({
                                apiKey: this.config.apiKey,
                            })];
                    case 3:
                        _b.sent();
                        return [4 /*yield*/, gapi.client.request({
                                path: "https://www.googleapis.com/drive/v3/files/" + documentId,
                            })];
                    case 4:
                        request = _b.sent();
                        return [3 /*break*/, 6];
                    case 5:
                        e_1 = _b.sent();
                        return [2 /*return*/];
                    case 6:
                        _a = request.result, name = _a.name, mimeType = _a.mimeType;
                        return [2 /*return*/, {
                                url: url,
                                title: name,
                                mimeType: mimeType
                            }];
                }
            });
        });
    };
    return GoogleDrive;
}());
exports.GoogleDrive = GoogleDrive;
